import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const AlgebraicStructures = () => (
  <DMModuleSubtopic
    title="Algebraic structures"
    videos={[
      "https://www.youtube.com/embed/vafhjfe_n9A",
      "https://www.youtube.com/embed/1f7prLLkJVM",
      "https://www.youtube.com/embed/q2pMSPCCu7s",
      "https://www.youtube.com/embed/yevF2hxzpjU",
      "https://www.youtube.com/embed/czTvriL27SQ",
      "https://www.youtube.com/embed/OUc2U5eYEig",
      "https://www.youtube.com/embed/n0sAprMTGFg",
      "https://www.youtube.com/embed/RihYAB596qs",
      "https://www.youtube.com/embed/lFFJrHBjrRE",
      "https://www.youtube.com/embed/FJXoX64MuD4",
      "https://www.youtube.com/embed/tCHbfhk2WTQ",
      "https://www.youtube.com/embed/jqiRQU6cZ94"
    ]}
    takeaways={[
      {image:"/dm_5.png"},
    
      { text: "Learn all four theorems in your teacher's class notes; out of four, one may come in CAT-1." },
      { text: "1",
        image:"/dm_6.png"
       },
      {image:"/dm_7.png"},
      { text: "2",
        image:"/dm_8.png"
      },
      { text: "3",
        image:"/dm_9.png"
       },
       {image:"/dm_10.png"},
      { text: "4",
        image:"/dm_11.png"
       },
       {image:"/dm_12.png"}
    ]}
    questions={[
      { text: "Prove that for any commutative monoid <M,*> the set of Idempotent elements of M forms a submonoid" },
      { text: "State and prove composition of semigroup homomorphism is also a semigroup homomorphism" },
      { text: "State and prove the necessary and sufficient condition for a non empty subset H of G to be a subgroup of the group (G,*)" },
      { text: "Verify Lagrange's Theorem for the subgroup generated by 4 of the group <Z17*,x17>" },
      { text: "Show that the set Q+ of all positive rational numbers forms an abelian group under the operation * defined by a*b=(1/2)ab where a,b belongs to Q+" },
      { text: "Write down the composition tables for (Z7,+7) and (Z7*,x7) where Z7*=Z7-{[0]} and verify whether they are groups" },
      { text: "Prove that the set of four functions f1, f2, f3, f4 on the set of non zero complex numbers C-{0} defined by f1(z)=z , f2(z)=-z , f3(z)=1/z and f4(z)=-1/z where z belongs to C-{0} forms an abelian group with respect to the composition of functions." },
      { text: "Show that the set of all real (2*2) matrix with elements a,b,c,d , where ad-bc is not equal to 0 is a group under matrix multiplication as binary operation" },
      { text: "Show that if every element in a group is its own inverse, then the group must be abelian" },
      { text: "Show that the set of all elements a of a group (G,*) such that a*x=x*a for every x belongs to G is a subgroup of G" },
      { text: "Prove that if G is a group in which (ab)^k=a^k.b^k for any three consecutive integers k, the G is abelian" },
      { text: "Verify whether G= {(a,b): a,b are rationals, a≠0} is a group or not under the binary operation * on G defined as (a,b)*(c,d)=(ac,ad+b). Is it an abelian group?" },
      { text: "The Cayley's table for a group defined on the set S={e,a,b,c,d,f} with respect to a binary operator * is given below determine",
        image:"/dm_13.png"
       },
      { text: "Given the generator matrix for the encoding function e:B3→B6. Decode the received words (i) 110101 (ii) 100100 (iii) 101011",
        image:"/dm_14.png"
       },
      { text: "Let e:B2→B6 be an (2,6) encoding function defined as e(00)=000000, e(01)=011101, e(10)=001110, e(11)=111111. (i) Find the minimum distance. (ii) How many errors can e detect? (iii) How many errors can e correct? (iv) Decode the word 101001." }
    ]}
    exampleVideos={[]}
  />
);

export default AlgebraicStructures;
